import { SellerBadgesListResp } from 'types/api/response/seller-badges-list-resp'

import { api } from './api'

export const getSellerBadgesList = (userId: number) =>
  api.get<SellerBadgesListResp>(`/seller_badges_list/${userId}`)
